module.exports = __webpack_public_path__ + "static/media/david.35fdacbd.png";